import axios from "axios";
import base_url from "../config/base_url";

export const sendTokenToBackend = async (userId, fcmToken) => {
  const token = localStorage.getItem("token")
  localStorage.setItem("fcmToken" , fcmToken)
  // return
  try {
    const res = await axios.post(`${base_url}/firebase/register-token`,{token:fcmToken},
    {
      headers: {
        Authorization: `Bearer ${token}`, // حط هنا التوكن اللي من الـ login
      },
    })
    localStorage.setItem("fcmToken" , fcmToken)
  } catch (error) {
    console.error("Error sending token to backend:", error);
  }
};
